import * as React from 'react'
import type { SVGProps } from 'react'
import { Ref, forwardRef } from 'react'

interface SVGRProps {
  title?: string
  titleId?: string
}
const CameraIcon = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23ZM11.1662 17L13.4885 20.8706C15.9801 20.4555 18.1251 19.0162 19.4762 17H11.1662ZM6.87657 13.7379L11.2091 20.9589C8.47823 20.7209 6.09696 19.2624 4.61389 17.1319L6.87657 13.7379ZM7.63148 9H3.51936C3.18745 9.93827 3.00683 10.948 3.00683 12C3.00683 13.0929 3.20176 14.1402 3.55875 15.1091L7.63148 9ZM20.4806 15H16.3143L20.3393 8.62714C20.761 9.6687 20.9932 10.8072 20.9932 12C20.9932 13.052 20.8126 14.0617 20.4806 15ZM12.8338 7H4.52377C5.87486 4.9838 8.01991 3.54446 10.5115 3.12945L12.8338 7ZM12.7909 3.04113L17.0347 10.1141L19.2257 6.64495C17.7345 4.6361 15.4254 3.27066 12.7909 3.04113ZM8.17925 12L10.0542 9H13.9458L15.8208 12L13.9458 15H10.0542L8.17925 12Z"
      fill="currentColor"
    />
  </svg>
)
const ForwardRef = forwardRef(CameraIcon)
export { ForwardRef as ReactComponent }
